import ReactDOM from "react-dom";
import packagejson from "../package.json";
import App from "./App";
import { logout } from "./redux/actions/auth";
import { finishUpdate, showUpdateDialog } from "./redux/actions/versionState";
import { store } from "./redux/store/store";

// Function to handle service worker updates with callback
function handleUpdate(registration) {
  // Caso donde ya se mostro el modal de actualización
  const updateInProgress = store.getState().versionState.updateInProgress;
  if (updateInProgress) {
    if (registration.waiting) {
      // Actualizar el service worker directamente.
      registration.waiting.postMessage({ action: "skipWaiting" });
    }
  } else {
    // Mostrar modal de actualización y esperar a que el usuario confirme.
    store.dispatch(showUpdateDialog(registration));
  }
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(CONFIG.path + "/service-worker.js")
    .then((registration) => {
      // Manejo instalacion nuevo service worker
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          // Solo se ejecuta cuando hay un nuevo service worker instalando y tengo un service worker previo.
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            const messageChannel = new MessageChannel();
            messageChannel.port1.onmessage = (event) => {
              if (event.data.action === "updateAvailable") {
                handleUpdate(registration);
              }
            };
            if (registration.waiting) {
              registration.waiting.postMessage(
                { action: "checkVersion", version: packagejson.version },
                [messageChannel.port2]
              );
            }
          }
        });
      });

      // Escuchamos a que el service worker tome control de la página
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Cuando tenga control de la pagina, finalizamos el proceso de actualización y actualizamos la página para obtener la nueva versión.
        store.dispatch(logout()).then(() => {
          store.dispatch(finishUpdate())
          window.location.reload();
        });

      });
    })
    .catch((error) => {
      console.log('Service worker registration failed:', error);
      store.dispatch(finishUpdate())
    });
}

ReactDOM.render(<App />, document.getElementById("root"));
